import { TimePeriod } from 'src/app/shared/dashboard/models/time-period.enum';

export class SetDeviationsOverTimeFilters {
  static readonly type = '[Dashboard Plugins] Set Deviations Over Time Filters';
  constructor(
    public filters: {
      vesselIds?: string[];
      deviationTypeIds?: string[];
      timePeriod?: TimePeriod;
      customDateRange?: {
        from: Date;
        to: Date;
      };
    }
  ) {}
}

export class SetDashboardModalOpen {
  static readonly type = '[Dashboard Plugins] Set Dashboard Modal Open';
  constructor(public isOpen: boolean) {}
}
